import { createContext, useContext, useState, useCallback, type ReactNode } from "react";
import DonationModal from "./DonationModal";

type DonationModalContextType = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
};

const DonationModalContext = createContext<DonationModalContextType | null>(null);

export const useDonationModal = (): DonationModalContextType => {
  const ctx = useContext(DonationModalContext);
  if (!ctx) {
    throw new Error("useDonationModal must be used within a DonationModalProvider");
  }
  return ctx;
};

export const DonationModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return (
    <DonationModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
      <DonationModal open={isOpen} onOpenChange={setIsOpen} />
    </DonationModalContext.Provider>
  );
};
